import { LoadingAnimation } from 'ui-builder';

export default LoadingAnimation;
